export const load = () => ({
	h1: 'Receiving Your IndowONE Inserts',
	title: 'How To Inspect And Open Your Inserts Safely',
	description:
		'Inspect your IndowONE shipment and safely remove your inserts to avoid damaging the materials.',
	showTitle: true,
});
